import React, {
  useEffect,
  useState,
} from 'react';

import axios from 'axios';

import {
  Link,
  useParams,
} from 'react-router-dom';

import './ProgrammeContentEditorPage.css';

/* global process */

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

const CONTENT_URL =
  `${API_BASE_URL}/api/v1/admin/programme_contents`;

const ProgrammeContentEditorPage = () => {
  const { id } = useParams();

  const [form, setForm] =
    useState(null);

  const [status, setStatus] =
    useState('loading');

  const [message, setMessage] =
    useState('');

  const [error, setError] =
    useState('');

  useEffect(() => {
    const loadContent = async () => {
      try {
        const response =
          await axios.get(
            `${CONTENT_URL}/${id}`
          );

        setForm({
          id: response.data.id,
          pilar_id:
            response.data.pilar_id,
          main:
            Boolean(response.data.main),

          title_2026_fr:
            response.data.title_2026_fr ||
            '',

          title_2026_en:
            response.data.title_2026_en ||
            '',

          content_2026_fr:
            response.data.content_2026_fr ||
            '',

          content_2026_en:
            response.data.content_2026_en ||
            '',

          historical_title:
            response.data.historical_title ||
            '',

          historical_content:
            response.data.historical_content ||
            '',
        });

        setStatus('ready');
      } catch (requestError) {
        setError(
          requestError.response?.data?.error ||
          requestError.message ||
          'Unable to load programme content.'
        );

        setStatus('failed');
      }
    };

    loadContent();
  }, [id]);

  const handleChange = (event) => {
    const {
      name,
      value,
      type,
      checked,
    } = event.target;

    setForm((current) => ({
      ...current,
      [name]:
        type === 'checkbox'
          ? checked
          : value,
    }));
  };

  const saveContent = async () => {
    try {
      setStatus('saving');
      setMessage('');
      setError('');

      const response =
        await axios.patch(
          `${CONTENT_URL}/${id}`,
          {
            programme_content: {
              title_2026_fr:
                form.title_2026_fr,

              title_2026_en:
                form.title_2026_en,

              content_2026_fr:
                form.content_2026_fr,

              content_2026_en:
                form.content_2026_en,

              main:
                form.main,

              pilar_id:
                form.pilar_id,
            },
          }
        );

      setForm((current) => ({
        ...current,
        ...response.data,
      }));

      setMessage(
        'Programme content saved.'
      );

      setStatus('ready');
    } catch (requestError) {
      setError(
        requestError.response?.data?.error ||
        requestError.message ||
        'Unable to save programme content.'
      );

      setStatus('ready');
    }
  };

  if (
    status === 'loading' ||
    !form
  ) {
    return (
      <main className="admin-page">
        <p>
          Loading programme content...
        </p>
      </main>
    );
  }

  return (
    <main className="admin-page">
      <header className="admin-page-header">
        <div>
          <p className="admin-eyebrow">
            Programme Content
          </p>

          <h1>
            Pillar {form.pilar_id}
          </h1>

          <p>
            Edit the bilingual 2026–2030
            content used by the public ACE
            programme pages.
          </p>
        </div>

        <Link
          to="/admin/programme-content"
          className="admin-secondary-link"
        >
          ← Programme Content
        </Link>
      </header>

      {message && (
        <div className="pce-message success">
          {message}
        </div>
      )}

      {error && (
        <div className="pce-message error">
          {error}
        </div>
      )}

      <section className="pce-editor">
        <header className="pce-record-header">
          <div>
            <span>
              Record #{form.id}
            </span>

            <strong>
              {form.main
                ? 'Main pillar content'
                : 'Supporting content'}
            </strong>
          </div>

          <label className="pce-main-toggle">
            <input
              type="checkbox"
              name="main"
              checked={form.main}
              onChange={handleChange}
            />

            <span>
              Main programme record
            </span>
          </label>
        </header>

        <section className="pce-section">
          <div className="pce-section-heading">
            <span>01</span>

            <div>
              <h2>English content</h2>

              <p>
                Public English programme
                presentation.
              </p>
            </div>
          </div>

          <div className="pce-fields">
            <label>
              <span>English title</span>

              <textarea
                rows="3"
                name="title_2026_en"
                value={
                  form.title_2026_en
                }
                onChange={handleChange}
              />
            </label>

            <label>
              <span>English content</span>

              <textarea
                rows="11"
                name="content_2026_en"
                value={
                  form.content_2026_en
                }
                onChange={handleChange}
              />
            </label>
          </div>
        </section>

        <section className="pce-section">
          <div className="pce-section-heading">
            <span>02</span>

            <div>
              <h2>French content</h2>

              <p>
                Présentation publique en
                français.
              </p>
            </div>
          </div>

          <div className="pce-fields">
            <label>
              <span>Titre français</span>

              <textarea
                rows="3"
                name="title_2026_fr"
                value={
                  form.title_2026_fr
                }
                onChange={handleChange}
              />
            </label>

            <label>
              <span>Contenu français</span>

              <textarea
                rows="11"
                name="content_2026_fr"
                value={
                  form.content_2026_fr
                }
                onChange={handleChange}
              />
            </label>
          </div>
        </section>

        <section className="pce-history">
          <p className="pce-history-label">
            Historical reference — read only
          </p>

          <h3>
            {form.historical_title ||
              'No historical title'}
          </h3>

          <p>
            {form.historical_content ||
              'No historical content stored for this record.'}
          </p>
        </section>

        <footer className="pce-actions">
          <button
            type="button"
            onClick={saveContent}
            disabled={
              status === 'saving'
            }
          >
            {status === 'saving'
              ? 'Saving...'
              : 'Save programme content'}
          </button>

          <Link
            to="/homes/main"
            target="_blank"
            rel="noopener noreferrer"
          >
            Preview public page ↗
          </Link>
        </footer>
      </section>
    </main>
  );
};

export default ProgrammeContentEditorPage;
